import * as Yup from 'yup';

export const editScoutAssistantsYopValidation = () => {
  return Yup.object().shape({
    activeAllAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
    activeSelectedAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
    activeCompressAssistants: Yup.array().required().min(1, 'pleaseChooseAtLeastOneAssistant'),
  });
};
